import { mktAxios } from './axios';
import {
  GetSurveyRequest,
  SurveyConfig,
} from '../models';

export const getTurnOffAutoRenewSurveyUrl = async (request: GetSurveyRequest) => (
  await mktAxios.post<SurveyConfig>('/surveys', request)
).data;
